import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getConsentDocuments } from './consentAsync';
import IConsentDocument from "models/Consent";
import Reducers from "types/Reducers";

interface IState {
  documents: IConsentDocument[] | null;
};

const initialState:IState = {
  documents: null,
};

const slice = createSlice({
  name: Reducers.Consent,
  initialState,
  reducers: {},
  extraReducers(builder) {
    // Get consent documents
    builder.addCase(getConsentDocuments.pending, (state) => {
      state.documents = null;
    });
    builder.addCase(getConsentDocuments.fulfilled, (state, action:PayloadAction<IConsentDocument[]>) => {
      state.documents = action.payload;
    });
  },
});

// export const { } = slice.actions;

export default slice.reducer;
